import { isNotEmpty } from "./strings";
import { url } from "./urls";

/**
 * 非同期通信
 * （ajaxの代替）
 */
export async function fetchPost({ action, data }) {
  // fetch実行
  const response = await fetch(url(action), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  // validate response status
  validResponseStatus(response);
  // response => data変換
  const response_data = await response.json();
  // validate error
  return validError(response_data);
}

/**
 * 非同期通信
 * （ajaxの代替）
 */
export async function fetchUpload({ action, data }) {
  // fetch実行
  const response = await fetch(url(action), {
    method: "POST",
    body: data,
  });
  // validate response status
  validResponseStatus(response);

  // response => data変換
  const response_data = await response.json();

  // validate error
  return validError(response_data);
}
function validError(response_data) {
  // エラー処理
  if (response_data != null) {
    if (isNotEmpty(response_data["error"])) {
      throw response_data["error"];
    } else if (isNotEmpty(response_data["error_message"])) {
      throw response_data["error_message"];
    }
  }
  return response_data;
}

function validResponseStatus(response) {
  // responseのエラーチェック
  if (response.status !== 200) {
    // 200以外ならばエラーメッセージを投げる
    throw `response.status = ${response.status}, response.statusText = ${response.statusText}`;
  }
}
